import type React from "react";
import { Link } from "react-router";
import { cn } from "@/lib/utils";
import {
	buttonClassNames,
	formClassNames,
} from "@/shared/constants/customStyleSets";

type Props = React.HTMLAttributes<HTMLDivElement> & {
	offer: React.ReactNode;
	buttonText?: string | null;
	buttonText2?: string | null;
};

export const OfferToUpgrade: React.FC<Props> = ({
	offer,
	buttonText,
	buttonText2,
	className,
	...otherProps
}) => {
	return (
		<div
			className={cn(
				formClassNames,
				"border-none text-white md:p-2 gap-4",
				className,
			)}
			data-testid="offer-to-upgrade"
			{...otherProps}
		>
			{offer}

			{(buttonText || buttonText2) && (
				<div className="flex items-center justify-center gap-4">
					{buttonText && (
						<Link to="/account?upgrade=true" className={buttonClassNames}>
							{buttonText}
						</Link>
					)}
					{buttonText2 && (
						<Link to="/account?upgrade=true" className={buttonClassNames}>
							{buttonText2}
						</Link>
					)}
				</div>
			)}
		</div>
	);
};
